export const backend = [
    "I design and develop the server-side logic.",
    "I ensure scalability and reliability.",
    "I integrate with other systems.",
    "I debug and troubleshoot."
]

export const frontend = [
    "I develop the user interfaces.",
    "I implement interactivity.",
    "I ensure cross-platform compatibility.",
    "I optimize performance."
]

export const psa = [
    "I analyze problems.",
    "I design algorithms with various data structures.",
    "I implement and test solutions.",
    "I continuously optimize solutions."
]